import React, { useState } from "react";
import "./Contact.css";

const Contact: React.FC = () => {
  const [form, setForm] = useState({ name: "", email: "",phone:"", message: "" });
  const [status, setStatus] = useState<"idle" | "loading" | "success" | "error">("idle");

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setStatus("loading");

    try {
      const res = await fetch("/api/send-email", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(form),
      });

      if (!res.ok) throw new Error("Failed to send email");

      setStatus("success");
      setForm({ name: "", email: "",phone:"", message: "" });
    } catch (error) {
      console.error("Error sending email:", error);
      setStatus("error");
    }
  };

  return (
    <div className="contact-container">
      <h2>Contact Us</h2>
      <p className="contact-intro">
        Please reach out and we will be in touch within 48 hours.  
        If you want a faster response, please call us at{" "}
        <a href="tel:+14034012747">+1 403-401-2747</a>.
      </p>
      <form className="contact-form" onSubmit={handleSubmit}>
        <label>
          Name
          <input
            type="text"
            name="name"
            value={form.name}
            onChange={handleChange}
            required
            autoComplete="off"
            disabled={status === "loading"}
          />
        </label>
        <label>
          Email
          <input
            type="email"
            name="email"
            value={form.email}
            onChange={handleChange}
            required
            autoComplete="off"
            disabled={status === "loading"}
          />
        </label>
        <label>
          Phone
          <input
            type="tel"
            name="phone"
            value={form.phone || ""}
            required
            onChange={handleChange}
            autoComplete="off"
            disabled={status === "loading"}/>
        </label>
        <label>
          Message
          <textarea
            name="message"
            value={form.message}
            onChange={handleChange}
            rows={5}
            required
            disabled={status === "loading"}
          />
        </label>
        <button
          type="submit"
          className="contact-submit-btn"
          disabled={status === "loading"}
        >
          {status === "loading"
            ? "Sending, please stay on this page for a moment..."
            : "Submit"}
        </button>

        {status === "success" && (
          <div className="contact-success">
            Thank you! We'll be in touch soon.
          </div>
        )}

        {status === "error" && (
          <div className="contact-error">
            Something went wrong. Please email us directly at{" "}
            <a href="mailto:info@transform365.ca">info@transform365.ca</a>.
          </div>
        )}
      </form>
    </div>
  );
};

export default Contact;
